import React from 'react';
import {animated} from '@react-spring/web';
import {ITile} from '@dazn/lp-web/src/types';
import {tileTypeConfig} from '@dazn/lp-web/src/utils/tileConfig';
import {useTileTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import SimpleResponsiveImage from '@dazn/lp-web/src/components/Images/SimpleResponsiveImage/SimpleResponsiveImage';
import styles from '@dazn/lp-web/src/components/ShowsRail/shows-rail.module.css';
import {navigateToDifferentChapterUrl} from '@dazn/lp-web/src/utils';
import {getWomenFootballCompetitions} from '@dazn/lp-web/src/features/getWomenFootBallCompetitionIds';
import {checkIfNflAvailableEnabled} from '../../features/getNflAvailable';

const ShowsTile: React.FC<{
    tile: ITile;
    index: number;
    slidesPerView: number;
    disableAnimation: boolean;
}> = ({tile, index, slidesPerView, disableAnimation}) => {
    const [refView, springs] = useTileTransitions();

    const isFreemiumTile = !tile.entitlementIds?.length;

    const isWomenFootBallCompetition = getWomenFootballCompetitions().includes(
        tile.competitionId as string
    );

    const animations = disableAnimation
        ? {}
        : (() => {
              if (index >= slidesPerView) return {};
              return {
                  style: springs,
                  ref: refView
              };
          })();

    const handleTileClick = (): void => {
        const tileContentType = tile.contentType;

        navigateToDifferentChapterUrl({
            chapterName: 'auth',
            chapterPath:
                tileContentType.toLocaleLowerCase() === 'nfl' &&
                checkIfNflAvailableEnabled()
                    ? `/account/content/${tileContentType}/signup`
                    : `/account/content/dazn/signup`,
            chapterData: {
                ...(isFreemiumTile ? {isFreemium: isFreemiumTile} : {}),
                ...(isWomenFootBallCompetition && !tile.entitlementIds?.length
                    ? {freemiumType: 'WOMENFOOTBALL'}
                    : {})
            }
        });
    };

    return (
        <animated.article {...animations} onClick={handleTileClick}>
            <div className={styles.showsTile}>
                <SimpleResponsiveImage
                    imageUrl={`${tile.portraitImageUrl ?? tile.imageUrl}`}
                    aspectRatio={tileTypeConfig.PORTRAIT.aspectRatio}
                />
                {tile?.logoUrl && (
                    <img
                        className={styles.logo}
                        src={tile?.logoUrl ?? ''}
                        alt="logo"
                    />
                )}
            </div>
            <div className={styles.showsTileTitle}>{tile.title}</div>
        </animated.article>
    );
};

export default ShowsTile;
